/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Ai_AssistantInputs */



/**
* | output |
* | --- |
* | "AI Assistant (Ask)" |
*
* @param {Signup_Compare_Ai_AssistantInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_ai_assistant = /** @type {((inputs?: Signup_Compare_Ai_AssistantInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Ai_AssistantInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "de") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "it") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "es") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
	return /** @type {LocalizedString} */ ("AI Assistant (Ask)")
});